import React, { useEffect, useState } from "react";
import { Menu, X, MessageCircle, Send, Gift } from "lucide-react";
import { BRAND, NAV_LINKS, waLink } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#060b16]/90 backdrop-blur-xl border-b border-[rgba(46,155,255,0.14)]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <img src={BRAND.logo} alt="THE REAL ALGO" className="h-10 w-10 rounded-lg object-cover ring-1 ring-[rgba(46,155,255,0.4)]" />
          <span className="font-extrabold tracking-tight text-[17px] leading-none">
            THE REAL <span className="text-blue-grad">ALGO</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[14px] text-slate-300 hover:text-white transition-colors relative flex items-center gap-1.5"
            >
              {l.badge && <Gift className="w-4 h-4 text-[#2e9bff]" />}
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a href={waLink("Hi, I'm interested in THE REAL ALGO EA")} target="_blank" rel="noreferrer"
            className="hidden sm:grid place-items-center w-9 h-9 rounded-full bg-[#0f1b30] border border-[rgba(46,155,255,0.25)] text-[#22e39a] hover:bg-[#132743] transition-colors">
            <MessageCircle className="w-4 h-4" />
          </a>
          <a href={BRAND.telegram} target="_blank" rel="noreferrer"
            className="hidden sm:grid place-items-center w-9 h-9 rounded-full bg-[#0f1b30] border border-[rgba(46,155,255,0.25)] text-[#2e9bff] hover:bg-[#132743] transition-colors">
            <Send className="w-4 h-4" />
          </a>
          <a href="#pricing" className="hidden sm:inline-flex btn-primary px-5 py-2.5 rounded-full text-sm font-semibold">
            Get Started
          </a>
          <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-1">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-[#060b16]/98 backdrop-blur-xl border-b border-[rgba(46,155,255,0.14)] px-5 py-4 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)}
              className="py-2.5 text-slate-200 hover:text-white flex items-center gap-2 border-b border-white/5">
              {l.badge && <Gift className="w-4 h-4 text-[#2e9bff]" />}{l.label}
            </a>
          ))}
          <a href="#pricing" onClick={() => setOpen(false)} className="btn-primary text-center mt-3 px-5 py-3 rounded-full text-sm font-semibold">
            Get Started
          </a>
        </div>
      )}
    </header>
  );
}
